import * as React from 'react';
import { DefaultLinkBehavior } from "./DefaultLinkBehavior";
export var LinkBehaviorContext = React.createContext(DefaultLinkBehavior);